import { QueryKey, UseInfiniteQueryOptions, useInfiniteQuery, useQuery } from 'react-query';
import { agencyDao } from 'shared/dao/agencyDao';
import { ICompanyResponsePayload } from 'shared/interfaces/ICompany';
import {
  IAgencyAccessCodeParams,
  IAgencyResponsePayload,
  IGetAgenciesParams,
  IGetAgenciesResponse,
} from 'shared/interfaces/utils/IAgency';
import { IAxiosErrorResponse } from 'shared/interfaces/utils/IAxios';

const {
  searchAgency: searchAgencyDao,
  getCompany: getCompanyDao,
  validateAgencyCode: validateAgencyCodeDao,
  getAgencies: getAgenciesDao,
} = agencyDao();
export const agencyService = () => {
  const searchAgency = (country: string, query: string) => {
    return useQuery<IAgencyResponsePayload, Error>(['agency', country, query], () => searchAgencyDao(country, query), {
      enabled: !!country && !!query,
    });
  };

  const validateAgencyCode = (params: IAgencyAccessCodeParams) => {
    return useQuery(['agency_code', params], () => validateAgencyCodeDao(params));
  };

  const getCompany = (company_slug: string) => {
    return useQuery<ICompanyResponsePayload, IAxiosErrorResponse>([company_slug], () => getCompanyDao(company_slug), {
      enabled: !!company_slug,
    });
  };

  const getAgencies = (
    payload: IGetAgenciesParams,
    isPublic?: boolean,
    options?: Omit<
      UseInfiniteQueryOptions<IGetAgenciesResponse, IAxiosErrorResponse, IGetAgenciesResponse, QueryKey>,
      'queryKey' | 'queryFn'
    >,
  ) => {
    return useInfiniteQuery<IGetAgenciesResponse, IAxiosErrorResponse, IGetAgenciesResponse>(
      ['agency_list', payload],
      () => getAgenciesDao({ ...payload }, isPublic),
      {
        getNextPageParam: (lastPage) => {
          return lastPage.data.agencies_connection?.pageInfo.hasNextPage
            ? lastPage.data.agencies_connection?.pageInfo.endCursor
            : undefined;
        },
        enabled: options?.enabled,
      },
    );
  };

  return {
    getAgencies,
    validateAgencyCode,
    getCompany,
    searchAgency,
  };
};
